<template>
    <ValidationObserver class="needs-validation form-custom-format filter-form" tag="form" ref="observer" @submit.prevent="onSubmitForm()" v-slot="{passes}">
            <mdbContainer>
              <label class="filter-label">Filter</label>

                <mdb-row >
                  <mdb-col col="12">
                      <ThatsInput tabindex="1" labelClass="col-sm-3" fieldClass="col-sm-9 pl-0" label="SKU/Code" placeholder="SKU/Code" vid="series" name="series" v-model="form.series" size="sm" />
                      <ThatsInput tabindex="2" labelClass="col-sm-3" fieldClass="col-sm-9 pl-0" label="Supplier Code" placeholder="Supplier Code" vid="supplier_code" name="supplier_code" v-model="form.supplier_code" size="sm" />
                      <ThatsInput tabindex="2" labelClass="col-sm-3" fieldClass="col-sm-9 pl-0" label="Item Name" placeholder="Item Name" vid="name" name="name" v-model="form.name" size="sm" />
                      
                  </mdb-col> 
                </mdb-row>

               
                <mdb-row>
                    <mdb-col col="3">
                        <label>Price Range</label>
                    </mdb-col>
                    <mdb-col col="9">
                      <div class="row">
                        <div class="col-md-5 pl-3">
                          <ThatsNumber tabindex="1" labelClass="" fieldClass="col-sm-12 pl-0" vid="rangeone" name="rangeone" v-model="form.range[0]" size="sm" />
                        </div>  
                        <div class="col-md-2">~</div>
                        <div class="col-md-5">
                          <ThatsNumber tabindex="1" labelClass="" fieldClass="col-sm-12 pl-0" vid="rangeone" name="rangeone" v-model="form.range[1]" size="sm" />
                        </div>  
                      </div>

                      <mdb-row>
                          <mdb-col col="12 pr-4">
                            <vue-slider class="mt-1 mb-1" v-bind="slider" v-model="form.range" ></vue-slider>
                          </mdb-col>
                      </mdb-row>

                    </mdb-col>
                </mdb-row>

                

                 <mdb-row class="mt-1 mb-1">
                    <mdb-col col="3">
                        <label>Select Area</label>
                    </mdb-col>
                    <mdb-col col="9">
                      <ThatsCheckbox tabindex="4" vid="area" orientation="inline" name="area" :data="areaComputed" v-model="form.area" />
                    </mdb-col>
                </mdb-row>

                <mdb-row >
                  <mdb-col col="12">
                    <ThatsMultiSelect  labelClass="col-md-3" fieldClass="col-md-9  pl-0" label="Brands" v-model="form.brands" :reduce="brand => brand.code" :reduceLabel="'brand'" :options="brandComputed"></ThatsMultiSelect>
                    <ThatsMultiSelect  labelClass="col-md-3" fieldClass="col-md-9  pl-0" label="Category" v-model="form.category" :reduce="category => category.code" :reduceLabel="'category'" :options="categoryComputed" ></ThatsMultiSelect>
                    <ThatsMultiSelect  labelClass="col-md-3" fieldClass="col-md-9  pl-0" label="Collections" v-model="form.collections" :reduce="collection => collection.code" :reduceLabel="'collection'" :options="collectionComputed" ></ThatsMultiSelect>
                    <ThatsMultiSelect  labelClass="col-md-3" fieldClass="col-md-9  pl-0" label="Colour" v-model="form.colour" :reduce="colour => colour.code" :reduceLabel="'colour'" :options="colorComputed" ></ThatsMultiSelect>

                  </mdb-col>
                </mdb-row>

                <mdb-row class="mt-1 mb-1">
                    <mdb-col col="3">
                    </mdb-col>
                    <mdb-col col="9">
                     <mdb-btn color="elegant" size="sm" @click="passes(onSubmitForm)">Search</mdb-btn>
                <mdb-btn color="elegant" size="sm" @click="clearForm">Clear Filter</mdb-btn>
                    </mdb-col>
                </mdb-row>


                
              </mdbContainer>


          </ValidationObserver>
</template>
<script>
import { mdbBtn,mdbContainer, mdbRow,mdbCol, mdbIcon} from "mdbvue";
import { ValidationObserver } from "vee-validate";
import { ThatsNumber,ThatsInput, ThatsSeriesInput, ThatsFieldset, ThatsCheckbox, ThatsMultiSelect} from '../../components/thats/Thats'
import {mapActions} from 'vuex';
import VueSlider from 'vue-slider-component'
export default {
    components: {
        mdbContainer,
        mdbBtn,
        mdbRow,
        mdbCol,  
        mdbIcon,
        ValidationObserver,
        ThatsInput,  ThatsNumber,
        ThatsSeriesInput,
        ThatsFieldset,
        ThatsCheckbox,
        ThatsMultiSelect,
        VueSlider,
  },
    inject : ['areaProvider','categoryProvider','collectionProvider','colorProvider','brandProvider'],
    data : () => ({
      form : {
          series : "",
          supplier_code : "",
          name : "",
          colour : [],
          range : [0,9999999],
          area : [],
          brands : [],
          category : [],
          collections : [],
      },

      colour : [],
      area : [],
      brands : [],
      category : [],
      collections : [],
      tooltipFormatter : v => `${('' + v).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`,
      slider:{
              width: '100%',
              min: 0, 
              max: 9999999,
              useKeyboard: true,
              enableCross: true,
              tooltipPlacement :'bottom',
              tooltipFormatter : (v) => {
                return `${('' + v).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
              }     
      }

    }),

    created(){
        const self = this;

        const user = JSON.parse(localStorage.getItem('user'));

        this.form.brands = user.location.attr.brands;

    },
    mounted(){
      const self = this;
     /*  self.GetArea().then(response => self.area = response);
      self.GetBrandErp().then(response => {
            const brand = [];
            response.forEach(element => {
              brand.push({brand : element.label,code : element.value})
            });
            self.brands = brand
          });
      self.GetCategory().then(response => {
            const category = [];
            response.forEach(element => {
              category.push({category : element.label,code : element.value})
            });
            self.category = category
          });
          self.GetBrandRelationship({'show_in' : 'product', 'endpoint' : 'collections'}).then((response) => {

            const collection = [];
            response.forEach(element => {
              collection.push({collection : element.name,code : element.mdbID})
            });
            self.collections = collection
        })

   
          self.getColour({'show_in' : 'product'}).then(response => {

          const c = [];

            if(response.length){
              response.forEach(e => {
                c.push({
                  colour : e.label,
                  code : e.slug,
                  attributes : e.attributes,
                })
              })
              self.colour = c
            }
        }) */
      self.form = this.formVar();
    },
    methods: {
      ...mapActions('ColourModule',[ 'getColour' ]),      
      ...mapActions('AreaModule',[ 'GetArea' ]),
      ...mapActions('BrandModule',[ 'GetBrandErp']),
      ...mapActions('CategoryModule',[ 'GetCategory']),
      ...mapActions('CollectionModule',[ 'GetCollections']),
      ...mapActions('ItemModule',[
        'GetBrandRelationship',
      ]),
        onSubmitForm(){
            this.$emit('filter',this.form)
        },

        formVar(){
          return {
                series : "",
                supplier_code : "",
                name : "",
                colour : [],
                range : [0,9999999],
                area : [],
                brands : [],
                category : [],
                collections : [],
            }
        },

        clearForm(){
          this.form = this.formVar()
        }



    },

    computed : {
        areaComputed : function(){
          return this.areaProvider();
        },
        categoryComputed : function(){
          return this.categoryProvider();
        },
        collectionComputed : function(){
          return this.collectionProvider();
        },
        colorComputed : function(){
          return this.colorProvider();
        },
        brandComputed : function(){
          return this.brandProvider();
        }
    }

}
</script>
